import { CardDataList } from "@components/CardDataList/CardDataList"
import { useAccountUtilitySerializer } from "@components/AccountNew/AccountInfoSidebar/utils/accountUtilitySerializerSchema"
import { useAccountStatusSerializer } from "@components/AccountNew/AccountInfoSidebar/utils/accountStatusSerializerSchema"
import { InfoIcon } from "lucide-react"
import { Button } from "@components/ui/button"
import { useDrawer } from "@contexts/DrawerContext"
import { AccountUtilityHistory } from "@components/AccountUtilityHistory/AccountUtilityHistory"
import { useAccountAboutSerializer } from "./utils/accountAboutSerializerSchema"

export const AccountInfoSidebar = ({ account_id }: { account_id: string }) => {
  const { openDrawer } = useDrawer()

  const { data: accountStatusData, isError: accountStatusIsError } =
    useAccountStatusSerializer(account_id)

  const { data: accountUtilityData, isError: accountUtilityIsError } =
    useAccountUtilitySerializer(account_id)

  const { data: accountAboutData, isError: accountAboutIsError } =
    useAccountAboutSerializer(account_id)

  return (
    <div className="tw:flex tw:flex-col tw:gap-3">
      <CardDataList
        sectionTitle="Account Status"
        items={accountStatusData.items}
        isError={accountStatusIsError}
      />
      <CardDataList
        sectionTitle="About"
        items={accountAboutData.items}
        isError={accountAboutIsError}
      />
      <CardDataList
        sectionTitle="Utility"
        items={accountUtilityData.items}
        isError={accountUtilityIsError}
      >
        <CardDataList.Action>
          <Button
            variant="outline"
            size="sm"
            onClick={() =>
              openDrawer(
                <AccountUtilityHistory account_id={account_id} />,
                "Utility History",
              )
            }
          >
            <InfoIcon />
          </Button>
        </CardDataList.Action>
      </CardDataList>
    </div>
  )
}
